import DatiClinicoStrumRicoveroEdit from "./components/DatiClinicoStrumRicoveroEdit.vue";
import DatiClinicoStrumRicoveroView from "./components/DatiClinicoStrumRicoveroView.vue";
import DatiClinicoStrumRicoveroList from "./components/DatiClinicoStrumRicoveroList.vue";

export default {
    DatiClinicoStrumRicoveroEdit,
    DatiClinicoStrumRicoveroView,
    DatiClinicoStrumRicoveroList,
};
